import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Dussehra2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/6.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/7.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/8.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/9.webp`;
    const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/10.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/11.webp`;
    const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/12.webp`;
    const p13 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/13.webp`;
    const p14 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/14.webp`;
    const p15 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/15.webp`;
    const p16 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/16.webp`;
    const p17 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/17.webp`;
    const p18 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/18.webp`;
    const p19 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/19.webp`;
    const p20 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/20.webp`;
    const p21 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/21.webp`;
    const p22 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/22.webp`;
    const p23 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/23.webp`;
    const p24 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/24.webp`;
    const p25 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/25.webp`;
    const p26 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/26.webp`;
    const p27 = `${config.base_image_url_2025}/home/events-activities/school-programs/DussehraCelebration/27.webp`;

    

   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
},
{
  src: p12,
  source: p12,
  rows: 1,
  cols: 1,
},
{
  src: p13,
  source: p13,
  rows: 1,
  cols: 1,
},
{
  src: p14,
  source: p14,
  rows: 1,
  cols: 1,
},
{
  src: p15,
  source: p15,
  rows: 1,
  cols: 1,
},
{
  src: p16,
  source: p16,
  rows: 1,
  cols: 1,
},
{
  src: p17,
  source: p17,
  rows: 1,
  cols: 1,
},
{
  src: p18,
  source: p18,
  rows: 1,
  cols: 1,
},
{
  src: p19,
  source: p19,
  rows: 1,
  cols: 1,
},
{
  src: p20,
  source: p20,
  rows: 1,
  cols: 1,
},
{
  src: p21,
  source: p21,
  rows: 1,
  cols: 1,
},
{
  src: p22,
  source: p22,
  rows: 1,
  cols: 1,
},
{
  src: p23,
  source: p23,
  rows: 1,
  cols: 1,
},
{
  src: p24,
  source: p24,
  rows: 1,
  cols: 1,
},
{
  src: p25,
  source: p25,
  rows: 1,
  cols: 1,
},
{
  src: p26,
  source: p26,
  rows: 1,
  cols: 1,
},
{
  src: p27,
  source: p27,
  rows: 1,
  cols: 1,
}
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                              Dussehra Celebrations
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                Date: 25 September 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                On 25 September 2025, the campus of National Public School Yeshwanthpur was buzzing with excitement and festive cheer as students, teachers and staff came together to celebrate Dussehra—a festival that beautifully symbolizes the victory of good over evil. 
                                <br></br>
                                The celebration commenced a week earlier with the depiction of different episodes of Ramayana in a sequence by grade 9 students as part of morning assemblies. On 25 September 2025 , the programme started  off with a warm and heartfelt welcome address setting the tone for the morning assembly full of performances and joy. A stunning dance drama from Lord Rama’s courage to Ravana’s defeat by students of grade 9, each scene was brought to life with passion and precision. The drama wrapped up the performance with a powerful and moving finale, leaving the audience completely absorbed. The event progressed with vibrant celebration as the students of Class 12 performed Garba. Their energetic movements, colourful costumes and enthusiasm left the audience clapping along with the beats. The stage was truly alive with joy and rhythm. 
                                <br></br>
                               The celebrations reached a spiritual crescendo with the Navadurga finale dance by girls of Class 9. With grace, strength, and devotion, each of the nine forms of Goddess Durga was beautifully portrayed, making it a performance that was both mesmerizing and deeply inspiring. Adding a soulful touch, the school choir filled the assembly with melodious devotional songs. Their harmonies perfectly complemented the performances, tying the entire celebration together with warmth and spirit.
                               <br></br>
                                This year’s Dussehra at National Public School Yeshwanthpur was more than just a celebration—it was a memorable experience of culture, unity and devotion that everyone will cherish for years!  The day was a perfect mix of devotion, energy and artistry, leaving everyone present enchanted.
                               <br></br>
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ The strength of a democracy lies in the ability of its citizens to question, engage, and actively participate in shaping its future.”

                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Dussehra2025;